module.exports = __webpack_public_path__ + "img/hyl_title1.4185ce7d.png";